import React, { useCallback, useEffect, useState } from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Font, pdf } from '@react-pdf/renderer';
import regular from '../../../assets/fonts/Montserrat/Montserrat-Regular.ttf';
import bold from '../../../assets/fonts/Montserrat/Montserrat-Bold.ttf';
import semibold from '../../../assets/fonts/Montserrat/Montserrat-SemiBold.ttf';
import medium from '../../../assets/fonts/Montserrat/Montserrat-Medium.ttf';
// import { getImageToken } from '../../../helpers/file_manager/backend_helper';
import { downloadFile as onDownloadFile } from '../../../slices/thunks';
import dayjs from 'dayjs';

Font.register({
    family: 'Montserrat',
    fonts: [
        { src: regular, fontWeight: 'normal' },
        { src: bold, fontWeight: 'bold' },
        { src: semibold, fontWeight: '600' },
        { src: medium, fontWeight: '500' },
    ],
});

const PageFooter = (render) => {
    return (
        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
            `Página ${pageNumber} de ${totalPages}`
        )} fixed />
    )
}

const Table = ({ headers, data, additionalStylesCell, contentColumnIndex, withoutBorderSeparator, noBorders}) => {
    return (
        <View 
            style={
                [
                    styles.table,
                    noBorders
                        ? styles.noBorderTable
                        : null
                ]
            }
        >
            ({
                headers ?
                (
                    <View style={[styles.row]}>
                        {headers.map((header, index) => (
                            <Text
                                key={index}
                                style={[
                                    styles.cell,
                                    styles.headerCell,
                                    index === 0
                                        ? styles.firstCell
                                        : null
                                ]}
                            >
                                {header.name}
                            </Text>
                        ))}     
                    </View>
                ) : null
            })
            {data.map((row, indexRow) => (
                <View
                    key={indexRow} 
                    style={styles.row}
                >
                    {(
                        Object.values(row).map((item, indexCell) => (
                        <Text
                            key={indexCell}
                            style={[
                                [
                                    styles.cell,
                                    indexCell === contentColumnIndex
                                    ? styles.autoCell
                                    : null,
                                    indexCell === 0
                                        ? styles.firstCell
                                        : null,
                                    !headers && indexRow === 0
                                        ? styles.firstCellWithoutHeader
                                        : null,
                                    withoutBorderSeparator
                                        ? styles.cellWithoutBorderLeft
                                        : null,
                                    noBorders
                                        ? styles.noBorderCell
                                        : null
                                ],
                                ...[additionalStylesCell[indexCell]]
                            ]}
                        >
                            {item}
                        </Text>
                        )
                    ))}
                </View>
            ))}
        </View>
    );
}

function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}

const getImage = async (dispatch, file) => {
    try{
        const responseBlob = await dispatch(
            onDownloadFile({
                file_id: file.document_id
            })
        ).unwrap()
        
        if(responseBlob){
            const payload = responseBlob;
            const image = await blobToBase64(payload);
            return {
                ...file,
                image: image
            }
        }
    } catch (err){
        console.error('Error al obtener documento.', err);
    } 
}

const handleDownloadImages = async (dispatch, photographics) => {
    const downloadedFiles = await Promise.all(
        (Array.isArray(photographics) ? photographics : []).map(
            async(item, index) => 
                await getImage(dispatch, item)
        )
    );
    return downloadedFiles.filter(Boolean)
}

const BeachCleaningReportTemplate = (
    logoSrc,
    dataBeachCleaning,
    responsible,
    dataExtractedResidues,
    dataExtractedGuides,
    images
) => {
    return (
        <Document>
            <Page style={styles.page}>
                <View style={styles.header}>
                    <Image style={styles.logo} src={logoSrc} />
                    <View style={styles.headerWrapper}>
                        <Text style={styles.headerWrapperText}>
                            LIMPIEZA SECTOR ALEDAÑO
                        </Text>
                        <Text style={styles.headerWrapperText}>
                            CENTRO DE CULTIVO, CENTRO DE LAGO, PISCICULTURA Y VIVERO (CENTRO DE ACOPIO)
                        </Text>
                    </View>
                
               
                </View>
                <View>
                    <Text style={styles.title}>Anexo I.</Text>
                    <Text style={styles.p}>
                        Registro de limpieza de sectores aledaños al centro de cultivo, centro de Lago, 
                        piscicultura, vivero (centro de acopio) y puerto bioseguro.
                    </Text>
                </View>
                <View>
                <Table
                    withoutBorderSeparator={true}
                    additionalStylesCell={[
                        [],
                        []
                    ]}
                    data={[
                        {
                            header: 'Sector',
                            data: ': ' + dataBeachCleaning?.sector?.name || '-'
                        },
                        {
                            header: 'Fecha Actividad',
                            data: ': ' + (dataBeachCleaning?.date ? dayjs(dataBeachCleaning.date).format('DD-MM-YYYY') : '-')
                        },
                        {
                            header: 'Encargado de Centro / Instalación',
                            data: ': ' + (`${responsible?.person?.first_name} ${responsible?.person?.last_name}` || '-')
                        },
                        { 
                            header: 'Nombre de la Instalación', 
                            data: ': ' + dataBeachCleaning?.sector?.establishment?.name || '-'
                        },
                        { 
                            header: 'N° de Guías de Despacho Residuos No Peligrosos', 
                            data: ': ' + (
                                (
                                    dataExtractedGuides.guidesNotDangerous
                                        .map(guide => guide.guide_number)
                                        .join()
                                ) ||
                                'No se han vinculado residuos no peligrosos a guías.'
                            )
                        },
                        {
                            header: 'N° de Guías de Despacho Residuos Peligrosos',
                            data: ': ' + (
                                (
                                    dataExtractedGuides.guidesDangerous
                                        .map(guide => guide.guide_number)
                                        .join()
                                ) ||
                                'No se han vinculado residuos peligrosos a guías.'
                            )
                        },
                    ]}
                    contentColumnIndex={0}
                />
                </View>
                <View>
                    <Text style={styles.subtitle}>1. Lista de Participantes</Text>
                    <Table
                        headers={[
                            { name: 'Nombre Participantes' },
                            { name: 'Cargo' },
                            { name: 'RUT'}
                        ]}
                        additionalStylesCell={[
                            [],
                            [{
                                textTransform: 'capitalize'
                            }]
                        ]}
                        data={
                            (dataBeachCleaning?.participants || []).map((item, index) => {
                                return {
                                    name: (
                                        item.person.first_name +
                                        ' ' +
                                        item.person.last_name
                                    ),
                                    position: (
                                        item?.organization ||
                                        item?.person?.user?.position ||
                                        '-'
                                    ),
                                    rut: item?.person?.rut || '-'
                                }}
                            )
                        }
                    />
                </View>
                <View>
                    <Text style={styles.subtitle}>2. Residuos Recolectados</Text>
                    <Table
                        headers={[
                            { name: 'Residuos No Peligrosos' },
                            { name: 'Kilogramos' },
                        ]}
                        additionalStylesCell={[
                            [],
                            [{
                                textAlign: 'right'
                            }]
                        ]}
                        data={
                            [
                                ...(dataExtractedResidues.residuesNotDangerous.map((item, index) => {
                                    return {
                                        name: item?.residue?.name || '-',
                                        kilograms: item.kilograms || ''
                                    }}
                                )),
                                ...[
                                    {
                                        name: 'TOTAL',
                                        kilograms: dataExtractedResidues.totalKilogramsNotDangerous
                                    }
                                ]
                            ]
                        }
                    />
                    <Table
                        headers={[
                            { name: 'Residuos Peligrosos' },
                            { name: 'Kilogramos' },
                        ]}
                        additionalStylesCell={[
                            [],
                            [{textAlign: 'right'}]
                        ]}
                        data={
                            [
                                ...(dataExtractedResidues.residuesDangerous.map((item, index) => {
                                    return {
                                        name: item?.residue?.name || '-',
                                        kilograms: item.kilograms || ''
                                    }}
                                )),
                                ...[
                                    {
                                        name: 'TOTAL',
                                        kilograms: dataExtractedResidues.totalKilogramsDangerous
                                    }
                                ]
                            ]
                        }
                    />
                </View>
                <PageFooter render />
            </Page>
            <Page style={styles.page}>
                <View>
                    <Text style={styles.subtitle}>3. Registros Fotográficos</Text>
                    {(images || []).map((image, index) => (
                        <View key={index}>
                            <View style={styles.imageWrapper}>
                                <Image src={image.image} style={styles.image}/>
                            </View>
                            <Table style={styles.photographicDetail}
                                additionalStylesCell={[
                                    [],
                                    []
                                ]}
                                withoutBorderSeparator={true}
                                noBorders={true}
                                data={[
                                    {
                                        header: 'Coordenadas de Ubicación',
                                        data: ': ' + (`Latitud (${image?.latitude ?? ''}) - Longitud (${image?.longitude ?? ''})`)
                                    },
                                    {
                                        header: 'Fecha de Registro',
                                        data: ': ' + (image.creation_date ? dayjs(image.creation_date).format('DD-MM-YYYY hh:mm:ss') : '-')
                                    },
                                    {
                                        header: 'Tipo de Imagen',
                                        data: ': ' + (image?.record_type?.name || '-')
                                    }
                                ]}
                                contentColumnIndex={0}
                            />
                        </View>
                    ))}
                </View> 
                <View>
                    <Text style={styles.subtitle}>4. Observaciones</Text>
                    <Text style={styles.p}>
                       {dataBeachCleaning.observation || 'Sin observaciones.'}
                    </Text>
                </View>
                <PageFooter render />
            </Page>
        </Document>
    );
};

const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontFamily: 'Helvetica',
        paddingBottom: 40
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
        verticalAlign: 'center'
    },
    logo: {
        width: 180,
        height: 'auto',
        paddingRight: 20,
        borderRight: 1,
        borderStyle: 'solid',
        objectFit: 'contain'
    },
    headerWrapper: {
        width: '100%',
        paddingLeft: 20,
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center'
    },
    headerWrapperText: {
        fontSize: 12,
        fontWeight: 'bold',
        marginBottom: 5
    },
    title: {
        fontSize: 14,
        marginBottom: 10
    },
    subtitle: {
        fontSize: 12,
        marginBottom: 5
    },
    p: {
        fontSize: 10,
        marginBottom: 10
    },
    text: {
        fontSize: 10
    },
    table: {
        display: 'table',
        width: 'auto',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#000',
        marginTop: 5,
        marginBottom: 10,
        fontSize: 10
    },
    noBorderTable: {
        borderWidth: 0
    },
    row: {
        flexDirection: 'row',
    },
    cellWithoutBorderLeft: {
        borderLeft: 0
    },
    cell: {
        padding: 3,
        borderLeftWidth: 1,
        borderTopWidth: 1,
        borderRightColor: '#000',
        borderTopColor: '#000',
        flex: 1
    },
    noBorderCell: {
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    autoCell: {
        flex: 0, // Prevent this column from expanding to fill space
        flexShrink: 0, // Don't shrink the column
        width: 'auto', // Let the content define the column width
        whiteSpace: 'nowrap', // Prevent text wrapping
        minWidth: 150 // Optional: Minimum width for cells
    },
    headerCell: {
        fontWeight: 'bold',
        textAlign: 'center',
        borderTopWidth: 0
    },
    firstCell: {
        borderLeftWidth: 0
    },
    firstCellWithoutHeader: {
        borderTopWidth: 0
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 6,
        bottom: 0,
        left: 0,
        right: 0,
        padding: 20,
        textAlign: 'right',
        color: 'grey'
    },
    photographicDetail: {
        paddingTop: 10,
        paddingBottom: 10
    },
    imageWrapper: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20
    },
    image: {
        width: '80%',
        objectFit: 'contain'
    }
});

const extractResidueData = (dataBeachCleaning) => {
    const residuesCollected = Array.isArray(dataBeachCleaning?.residues_collected)
        ? dataBeachCleaning.residues_collected
        : [];

    const residuesNotDangerous = residuesCollected
        .filter(
            residue => 
                (
                    residue?.residue?.residue_category?.residue_type_id == 
                    '662efd078ddfdcb64699a9ad'
                )
        )
    const totalKilogramsNotDangerous = residuesNotDangerous
        .map(residue => residue?.kilograms || 0)
        .reduce((acc, num) => acc + num, 0); 

    const residuesDangerous = residuesCollected
        .filter(
            residue => 
                (
                    residue?.residue?.residue_category?.residue_type_id ==
                    '662efcff8ddfdcb64699a9ac'
                )
        )
    const totalKilogramsDangerous = residuesDangerous
        .map(residue => residue?.kilograms || 0)
        .reduce((acc, num) => acc + num, 0);
    
    return {
        residuesNotDangerous: residuesNotDangerous,
        totalKilogramsNotDangerous: totalKilogramsNotDangerous,
        residuesDangerous: residuesDangerous,
        totalKilogramsDangerous: totalKilogramsDangerous
    }
}

const extractGuidesData = (dataBeachCleaning) => {
    const guides = Array.isArray(dataBeachCleaning?.guides)
        ? dataBeachCleaning.guides
        : [];

    const guidesNotDangerous = guides
        .filter(
            guide => 
                (
                    guide?.residue_type_id ==
                    '662efd078ddfdcb64699a9ad'
                )
        )

    const guidesDangerous = guides
        .filter(
            guide => 
                (
                    guide?.residue_type_id ==
                    '662efcff8ddfdcb64699a9ac'
                )
        )
    
    return {
        guidesNotDangerous: guidesNotDangerous,
        guidesDangerous: guidesDangerous
    }
}

const getResponsibleBeachCleaning = (participants) => {
    return (participants || []).find(
        participant => 
            participant.responsible === true
    )
}

export const generateBeachCleaningReportPDF = async (
    dispatch,
    logoSrc,
    dataBeachCleaning,
    photographics
) => {
    const responsible = getResponsibleBeachCleaning(dataBeachCleaning?.participants)
    const dataExtractedResidues = extractResidueData(dataBeachCleaning)
    const dataExtractedGuides = extractGuidesData(dataBeachCleaning)
    const images = await handleDownloadImages(
        dispatch,
        photographics
    )
    const beachCleaningReport = BeachCleaningReportTemplate(
        logoSrc,
        dataBeachCleaning,
        responsible,
        dataExtractedResidues,
        dataExtractedGuides,
        images
    );

    try {
        const blob = await pdf(
            beachCleaningReport
        ).toBlob();
        const file = new File(
            [blob],
            (
                'Reporte Limpieza Sector Aledaño' +
                ' ' +
                dataBeachCleaning?.sector?.name +
                ' ' +
                (
                    dayjs(new Date())
                    .format('DD-MM-YYYY hh:mm:ss')
                ) +
                '.pdf'
            ),
            {type: 'application/pdf'}
        );
        return file 
    } catch (error) {
        console.error("Failed to generate PDF:", error);
    }
};